import { useRouter, useRoute } from 'nuxt/app'
import { routes } from "~/constants/routes";
import { usePagination } from "~/composables/usePagination";

export const useNavigation = () => {
	const route = useRoute();
	const router = useRouter();

	// 1) 경로별로 usePagination을 미리 호출
	const boardPagination		= usePagination(routes.boardPage);
	const userPagination		= usePagination(routes.userPage);
	const facilityPagination	= usePagination(routes.facilityPage);
	const terminalPagination	= usePagination(routes.terminalPage);
	const termsPagination		= usePagination(routes.termsPage);
	// 2) "path → pagination 훅" 맵 생성
	const paginationMap: Record<string, ReturnType<typeof usePagination>> = {
		[routes.boardPage]:			boardPagination,
		[routes.userPage]:			userPagination,
		[routes.facilityPage]:		facilityPagination,
		[routes.terminalPage]:		terminalPagination,
		[routes.termsPage]:			termsPagination,
	};
	// "/management/board/xxx" → "/management/board"
	const getSection = (path: string) => {
		const seg = path.split('/').filter(Boolean)
		// seg = ['management','board','board_page'] 등
		if (seg.length >= 2) return `/${seg[0]}/${seg[1]}`
		return path;
	}

	// ✅ 메뉴 클릭 시 페이지 이동 및 활성화 클래스 적용
	const goToPage = (path: string) => {
		const fromSection = getSection(route.path)
		const toSection   = getSection(path)

		// 같은 섹션이면 초기화 스킵
		if (fromSection !== toSection) {
			//메뉴로 페이지 이동이 이루어진 경우 페이지 번호 초기화
			paginationMap[path]?.setPage(1);
		}

		router.push(path)
			.then(() => {

				// 페이지 이동이 완료된 후 활성화 클래스를 적용하는 로직을 추가
				// 예시: activeMenu.value = path;
				// 추후 배포시 주석
				// console.log(`페이지 이동 완료: ${path}`);
			})
			.catch((error) => {
				console.error('페이지 이동 중 오류 발생:', error);
			});
	};

	// 상세 페이지로 이동하는 함수 (boardId를 이용)
	const goToDetail = (path: string, id: string | number) => {
		router.push({ path: path, query: { id: id } })
			.then(() => {
				// console.log(`상세 페이지 이동 완료: ${path}, id: ${id}`);
			})
			.catch((error) => {
				console.error('상세 페이지 이동 중 오류 발생:', error);
			});
	};

	return { goToPage, goToDetail };
};